<template>
    <div :class="defaultOpen == 'preview' && 'exhibition'">
        <mavon-editor
            v-model="content" 
            ref="md" 
            @change="change"
            :toolbars='toolbars'
            @imgAdd='_imgAdd'
            :style="styleEditor"
            :subfield="subfield"
            :defaultOpen="defaultOpen"
            :toolbarsFlag="toolbarsFlag"
            :navigation="navigation"
            :autofocus="autofocus"
            :boxShadow="boxShadow"
            :previewBackground="previewBackground"
        />
    </div>
</template>

<script>
import { mavonEditor } from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import axios from 'axios';
import { uploadFile } from "@/api/index";
    export default {
    // 注册
    components: {
        mavonEditor,
    },
    props: {
        content: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        styleEditor: {
            type: String,
            default: 'min-height: 500px'
        },
        subfield: {
            type: Boolean,
            default: true // true： 双栏(编辑预览同屏)， false： 单栏(编辑预览分屏)
        },
        defaultOpen: {
            type: String,
            default: '' // edit： 默认展示编辑区域 ， preview： 默认展示预览区域 , 其他 = edit
        },
        toolbarsFlag: {
            type: Boolean,
            default: true // 工具栏是否显示
        },
        navigation: {
            type: Boolean,
            default: false // 默认展示目录
        },
        autofocus: {
            type: Boolean,
            default: true // 自动聚焦到文本框
        },
        boxShadow: {
            type: Boolean,
            default: true // 开启边框阴影
        },
        previewBackground: {
            type: String,
            default: '#fbfbfb' // 预览背景图
        },
    },
    data() {
        return {
            // content:'', // 输入的markdown
            modalShow1: false,
            html:'',    // 及时转的html
            url: '',
            // token: this.$tool.localGet('accessToken'),
            toolbars: {
              bold: true, // 粗体
              italic: true, // 斜体
              header: true, // 标题
              underline: true, // 下划线
              strikethrough: true, // 中划线
              mark: true, // 标记
              superscript: true, // 上角标
              subscript: true, // 下角标
              quote: true, // 引用
              ol: true, // 有序列表
              ul: true, // 无序列表
              link: true, // 链接
              imagelink: true, // 图片链接
              code: false, // code
              table: true, // 表格
              readmodel: true, // 沉浸式阅读
              htmlcode: true, // 展示html源码
              help: true, // 帮助
              undo: true, // 上一步
              redo: true, // 下一步
              trash: true, // 清空
              navigation: true, // 导航目录
              alignleft: true, // 左对齐
              aligncenter: true, // 居中
              alignright: true, // 右对齐
              subfield: true, // 单双栏模式
              preview: true, // 预览
            }
        }
    },
    created () { 
    },
    methods: {
        // 所有操作都会被解析重新渲染
        change(value, render){
            this.html = render;
            this.$emit('handleReturnMarkData', { value, key: this.id });
        },
        _imgAdd(pos, _file) {
          let that = this;
          var formdata = new FormData();
          formdata.append('file', _file);
          axios({
              url: uploadFile,
              method: 'post',
              data: formdata,
              headers: { 
                'Content-Type': 'multipart/form-data',
                accessToken: that.getStore("accessToken"),
                from:'pc'
              },
          }).then((res) => {
              this.$refs.md.$img2Url(pos, res.result);
          })
            
        },
    },
    mounted() {
    },
    watch: {
    },
    computed: {
    }
}
</script>

<style lang="less" scoped>
.exhibition{
    /deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content{
        padding: 0 !important;
        height: auto;
        border: none;
    }
    /deep/ .v-note-wrapper{
        border: none;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/practise/components/mavonEditor.vue